
// From: https://math.stackexchange.com/questions/854535/how-can-i-find-the-smallest-enclosing-circle-for-a-rectangle
const EnclosingCircleForRect = function(w, h) {
	return Math.sqrt(Math.pow(w, 2) + Math.pow(h, 2)) / 2
}

export default EnclosingCircleForRect
